/*
* Copyright (c) 2006-2007 Erin Catto http://www.gphysics.com
*
* This software is provided 'as-is', without any express or implied
* warranty.  In no event will the authors be held liable for any damages
* arising from the use of this software.
* Permission is granted to anyone to use this software for any purpose,
* including commercial applications, and to alter it and redistribute it
* freely, subject to the following restrictions:
* 1. The origin of this software must not be misrepresented; you must not
* claim that you wrote the original software. If you use this software
* in a product, an acknowledgment in the product documentation would be
* appreciated but is not required.
* 2. Altered source versions must be plainly marked as such, and must not be
* misrepresented as being the original software.
* 3. This notice may not be removed or altered from any source distribution.
*/
var b2PairCallback = /** @class */ (function () {
    function b2PairCallback() {
    }
    //virtual ~b2PairCallback() {}
    // This returns the new pair user data.
    b2PairCallback.prototype.PairAdded = function (proxyUserData1, proxyUserData2) { return null; };
    // This should free the pair's user data. In extreme circumstances, it is possible
    // this will be called with null pairUserData because the pair never existed.
    b2PairCallback.prototype.PairRemoved = function (proxyUserData1, proxyUserData2, pairUserData) { };
    return b2PairCallback;
}());
export { b2PairCallback };
